<template>
  <div class="CreatvallStyle">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="80px"
      class="CreatVhallForm"
    >
      <el-form-item label="商品名称" prop="title">
        <el-input v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="商品型号" required>
        <el-col :span="11">
          <el-input v-model="ruleForm.topic"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="定价">
        <el-col :span="11">
          <el-input v-model="ruleForm.price"></el-input>
        </el-col>
      </el-form-item>
      <el-form-item label="商品简介">
        <el-input type="textarea" v-model="ruleForm.describes"></el-input>
      </el-form-item>
      <el-form-item label="厂商名称">
        <el-input type="textarea" v-model="ruleForm.publisher"></el-input>
      </el-form-item>
      <el-form-item label="商品图片">
        <el-upload
          class="avatar-uploader"
          action="string"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :http-request="UploadImage"
        >
          <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存后关闭</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { creatlive, netmettingupdate } from "@/api/VhallLive";
import { actionuploadImg } from "@/api/img";
import { saveGoods, UpdateGoods } from "@/api/sysinfo";
export default {
  name: "AddGoods",
  props: {
    dialogData: {
      type: Object,
      default: () => ({
        title: "", // 商品名称
        topic: "", // 商品型号
        publisher: "", // 厂家名称
        price: "", // 定价
        describes: "", // 商品简介
        imageUrl: "", // 商品图片
        goodsType: "",
        linkId: ""
      })
    },
    IsEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        title: [{ required: true, message: "请输入商品名称", trigger: "blur" }],
        isbn: [{ required: true, message: "请输入商品型号", trigger: "blur" }],
        goodsType: [
          { required: true, message: "请选择商品类别", trigger: "change" }
        ]
      },
      ruleForm: {
        title: "", // 商品名称
        isbn: "", // 商品型号
        publisher: "", // 厂家名称
        price: "", // 定价
        desc: "", // 商品简介
        imageUrl: "", // 商品图片
        goodsType: 3,
        linkId: ""
      },
      // 直播
      imageUrl: "",
      LiveUrl: false,
      options: [
        {
          value: 1,
          label: "纸质书"
        },
        {
          value: 2,
          label: "电子书"
        },
        {
          value: 3,
          label: "非书籍"
        }
      ]
    };
  },
  created() {},
  mounted() {
    if (this.IsEdit) {
      this.ruleForm = this.dialogData;
    }
  },
  methods: {
    // 图片上传
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    // 文件提交
    UploadImage(param) {
    //   console.log(param.file);
      const formData = new FormData();
      formData.append("file", param.file);
    //   console.log(formData.has("file"));
      actionuploadImg(formData).then(response => {
        // console.log(response);
        this.ruleForm.imageUrl = response;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 提交
    onSubmit() {
      if (this.ruleForm.title === "") {
        this.$message({
          message: "商品名称不能为空",
          type: "warning"
        });
        return;
      }
      if (this.ruleForm.topic === "") {
        this.$message({
          message: "商品型号不能为空",
          type: "warning"
        });
        return;
      }
      let params = this.ruleForm;
      params.goodsType = 3;
      if (this.IsEdit) {
        UpdateGoods(params).then(data => {
        //   console.log(data);
        });
      } else {
        // 新增
        saveGoods(params).then(data => {
        //   console.log(data);
        });
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.CreatvallStyle {
}

.title {
  font-size: 20px;
  padding: 15px 0px 0px 15px;
}

.CreatVhallForm {
  width: 500px;
  margin-top: 50px;
}

/* 直播 */
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 300px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dotted;
}

.avatar {
  width: 300px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/SysManager/ClassifyInfo/components/addGoods.vue